// extracted by mini-css-extract-plugin
module.exports = {"menu-list-section-item":"MenuList-module__menu-list-section-item___2nBT3","menu-list-section-wrapper":"MenuList-module__menu-list-section-wrapper___2qv0w"};